module.exports = __webpack_public_path__ + "img/alipayAuthorization.bb9a695f.png";